export const Currency = Object.freeze({
    RealBRL: 'BRL',
    DolarUSD: 'USD',
});

export const getCurrencyTypes = () => [
    { label: 'Real Brasileiro', value: Currency.RealBRL },
    { label: 'Dólar Americano', value: Currency.DolarUSD },
];

export const getCurrencySimbol = (currency) => {
    const currencySimbol = new Map([
        [Currency.RealBRL, "R$"],
        [Currency.DolarUSD, "$"],
    ]);

    const defaultSimbol = "$";
    return currencySimbol.get(currency) || defaultSimbol;
};

export const formatCurrency = (currency, value) => {
    if (value === undefined || value === null) return 'N/A';

    const currencyLocales = new Map([
        [Currency.RealBRL, 'pt-BR'],
        [Currency.DolarUSD, 'en-US'],
    ]);

    const locale = currencyLocales.get(currency) || 'en-US';

    const formattedValue = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);

    return formattedValue;
};
